import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import { uploadFile, comment } from '@/services/http';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.isloading = false; // 图片上传
    _this.details = ''; // 订单详情信息
    _this.maxpic = false; // 是否上传到最大数量
    _this.imgids = ''; // 上传图片id
    _this.showText = ['非常差', '差', '一般', '好', '非常好']; // 星级对应文字描述
    _this.dialogVisible = false;
    _this.num = 3;
    _this.timer = '';
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      var commentDetails = sessionStorage.getItem('commentDetails');
      var details = commentDetails ? JSON.parse(commentDetails) : [];
      this.details = details.map(function (item) {
        var data = {};
        data.orderNo = item.orderNo;
        data.orderDetailId = item.id;
        data.productName = item.productName;
        data.sourceUrl = item.mallImage.sourceUrl;
        data.starLevel = 5;
        data.content = '';
        data.fileList = [];
        data.imgids = '';
        return data;
      });
    }
  }, {
    key: "uploadClick",
    value: function uploadClick(e) {
      e.currentTarget.querySelector('input').click();
    }
    // 上传图片
  }, {
    key: "uploadpic",
    value: function () {
      var _uploadpic = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(event, index) {
        var file, uploadlength, form, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.isloading = true;
              file = _toConsumableArray(event.target.files);
              if (!(file.length > 0 && file[0].size / 1024 > 2048)) {
                _context.next = 6;
                break;
              }
              this.$message.warning('每张不超过2m，支持jpg、png');
              this.isloading = false;
              return _context.abrupt("return");
            case 6:
              if (!(this.details[index].fileList.length < 3)) {
                _context.next = 15;
                break;
              }
              uploadlength = 3 - this.details[index].fileList.length;
              form = new FormData();
              file.forEach(function (value) {
                form.append('fileData', value);
                form.append('type', '11');
              });
              _context.next = 12;
              return uploadFile(form);
            case 12:
              res = _context.sent;
              if (res.data.code === 100) {
                this.details[index].fileList = [].concat(_toConsumableArray(this.details[index].fileList), _toConsumableArray(res.data.data.slice(0, uploadlength)));
                if (this.details[index].fileList.length === 3) {
                  this.maxpic = true;
                }
                this.details[index].imgids = this.details[index].fileList.map(function (e) {
                  return e.id;
                }).join(',');
              } else {
                this.$message.error(res.data.message);
              }
              this.isloading = false;
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function uploadpic(_x, _x2) {
        return _uploadpic.apply(this, arguments);
      }
      return uploadpic;
    }() // 删除图片
  }, {
    key: "removefile",
    value: function removefile(index, idx) {
      this.details[index].fileList.splice(idx, 1);
      this.details[index].imgids = this.details[index].fileList.map(function (e) {
        return e.id;
      }).join(',');
      this.maxpic = false;
    }
    // 发表评价
  }, {
    key: "addEvaluate",
    value: function () {
      var _addEvaluate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this2 = this;
        var evaluateJsonArr, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              evaluateJsonArr = [];
              this.details.forEach(function (item) {
                var obj = {};
                obj.orderDetailId = item.orderDetailId;
                obj.starLevel = item.starLevel;
                obj.content = item.content;
                obj.imageIds = item.fileList.length === 0 ? '' : item.imgids;
                evaluateJsonArr.push(obj);
              });
              _context2.next = 4;
              return comment({
                orderNo: this.details[0].orderNo,
                evaluateJsonArr: JSON.stringify(evaluateJsonArr)
              });
            case 4:
              res = _context2.sent;
              if (res.data && res.data.code === 100) {
                this.dialogVisible = true;
                this.timer = setInterval(function () {
                  if (_this2.num === 1) {
                    _this2.dialogVisible = false;
                    clearInterval(_this2.timer);
                    _this2.$router.push('/evaluation-list');
                    return;
                  }
                  _this2.num -= 1;
                }, 1000);
                sessionStorage.removeItem('commentDetails');
              } else {
                this.$message.error(res.data.message);
              }
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function addEvaluate() {
        return _addEvaluate.apply(this, arguments);
      }
      return addEvaluate;
    }() // 关闭成功发表窗口回调
  }, {
    key: "closeDialog",
    value: function closeDialog() {
      clearInterval(this.timer);
      this.$router.push('/evaluation-list');
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer
  }
})], default_1);
export default default_1;